import { KnowledgeChannel } from './types';
import { KnowledgeLocale } from './knowledgeCopy';

/** Strip control chars and normalize SF Knowledge HTML for dangerouslySetInnerHTML. */
export function sanitizeKnowledgeHtml(
  html: string,
  locale: KnowledgeLocale,
  channel: KnowledgeChannel
): string {
  if (!html) return '';

  const helpArticleBase = `/${locale}/help/article`;
  const heroArticleBase = `/${locale}/hero/article`;

  let normalized = html.replace(/[\x00-\x08\x0b\x0c\x0e-\x1f]/g, '');

  const sfHostPattern = '(?:https?:\\/\\/)?(?:urban\\.force\\.com|urbanco\\.my\\.site\\.com)';

  normalized = normalized
    .replace(new RegExp(`${sfHostPattern}/help/s/article/`, 'gi'), `${helpArticleBase}/`)
    .replace(new RegExp(`${sfHostPattern}/hero/s/article/`, 'gi'), `${heroArticleBase}/`)
    .replace(/urban\.force\.com\/help\/s\/article\//gi, `${helpArticleBase}/`)
    .replace(/urban\.force\.com\/hero\/s\/article\//gi, `${heroArticleBase}/`)
    .replace(/urbanco\.my\.site\.com\/help\/s\/article\//gi, `${helpArticleBase}/`)
    .replace(/urbanco\.my\.site\.com\/hero\/s\/article\//gi, `${heroArticleBase}/`)
    .replace(/urban\.force\.com\/help\/s/gi, `/${locale}/help`)
    .replace(/urban\.force\.com\/hero\/s/gi, `/${locale}/hero`)
    .replace(/urbanco\.my\.site\.com\/help\/s/gi, `/${locale}/help`)
    .replace(/urbanco\.my\.site\.com\/hero\/s/gi, `/${locale}/hero`)
    .replace(/href="\/article\//gi, `href="/${locale}/${channel}/article/`);

  normalized = normalizeSalesforceListHtml(normalized);

  return normalized.trim();
}

/** Salesforce often wraps list item text in <p>, which breaks bullet alignment. */
function normalizeSalesforceListHtml(html: string): string {
  let result = html;
  for (let i = 0; i < 5; i += 1) {
    const next = result.replace(
      /<li([^>]*)>\s*<p[^>]*>([\s\S]*?)<\/p>\s*<\/li>/gi,
      '<li$1>$2</li>'
    );
    if (next === result) {
      break;
    }
    result = next;
  }
  return result;
}
